<template>
    <div class="products">
        <div class="data-container">
            <b-table
                show-empty
                :empty-text="(loading) ? 'Loading data' : 'No product records found'"
                :fields="fields"
                :items="productInventoryListByBranch"
                responsive>
                <template slot="product_name" slot-scope="data">
                    {{ data.item.product_details.name }}
                </template>
                <template slot="variation_code" slot-scope="data">
                    {{ transformVariationName(data.item.decoded_variation_code) }}
                </template>
                <template slot="product_type" slot-scope="data">
                    <span class="text-capitalize">
                        {{ data.item.product_details.type }}
                    </span>
                </template>
                <template slot="regular_price" slot-scope="data">
                    Php {{ data.item.regular_price | regularPrice }}
                </template>
                <template slot="sale_schedule" slot-scope="data">
                    <template v-if="data.item.on_sale === 0">
                        N/A
                    </template>
                    <template v-else>
                        {{data.item.on_sale_from | formatDate}} - {{data.item.on_sale_to | formatDate}}
                    </template>
                </template>
                <template slot="sale_price" slot-scope="data">
                    <template v-if="data.item.on_sale === 0">
                        N/A
                    </template>
                    <template v-else-if="new Date(data.item.on_sale_to) < Date.now()">
                        N/A
                    </template>
                    <template v-else>
                        Php {{ data.item.sale_price }}
                    </template>
                </template>
                <template slot="sale_schedule" slot-scope="data">
                    <template v-if="data.item.on_sale === 0">
                        N/A
                    </template>
                    <template v-else>
                        {{data.item.on_sale_from | formatDate}} - {{data.item.on_sale_to | formatDate}}
                    </template>
                </template>
                <template slot="visibility" slot-scope="data">
                    <div id="product-visibility">
                        <switches 
                            v-model="data.item.visibility"
                            :emit-on-mount="false"
                            theme="custom"
                            color="primary"
                            text-enabled="On"
                            text-disabled="Off"
                            type-bold="true"
                            disabled>
                        </switches>
                    </div>
                </template>
                <template slot="action" slot-scope="data">
                    <b-row no-gutters>
                        <b-col>
                            <i class="action-button">
                                <img src="@/assets/images/actions/edit.svg"
                                    alt="Edit Button"
                                    @click="editProduct({
                                        uuid: data.item.uuid,
                                        product_uuid: data.item.product_details.uuid,
                                        product_type: data.item.product_details.type
                                    })">
                            </i>
                        </b-col>
                    </b-row>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import Switches from "vue-switches";
import moment from "moment";

export default {
    data() {
        return {
            fields: [
                {
                    key: "product_name",
                    sortable: true
                },
                {
                    key: "product_type",
                    sortable: true
                },
                {
                    key: "variation_code",
                    label: "Variation",
                    sortable: true
                },
                {
                    key: "regular_price",
                    label: "Price",
                    sortable: true
                },
                {
                    key: "sale_price",
                    sortable: true
                },
                {
                    key: "sale_schedule"
                },
                {
                    key: "stock",
                    label: "Stock Qty."
                },
                "visibility",
                "action"
            ]
        };
    },
    components: {
        Switches
    },
    filters: {
        formatDate: function(value) {
            if (value) {
                return moment(String(value)).format("MMM. D, YYYY");
            }
        },
        regularPrice: function(value) {
            return Number.parseFloat(value).toFixed(2);
        },
        salePrice: function(price, discount, discountType) {
            if (discountType === "PHP") {
                let formatDiscount = price - discount;
                return formatDiscount.toFixed(2);
            } else {
                let formatDiscount = price - price * (discount / 100);
                return formatDiscount.toFixed(2);
            }
        }
    },
    methods: {
        editProduct: function(param) {
            this.$store.commit("estoreLocations/setModal", {
                type: "edit_product",
                status: true
            });
            this.$store.commit(
                "estoreLocations/setEditingFromLocationsPage",
                true
            );
            this.$store.dispatch("estoreInventories/getProduct", {
                uuid:
                    param.product_type == "simple"
                        ? param.uuid
                        : param.product_uuid,
                type: param.product_type,
                payload: {
                    branch_uuid: this.branchInfo.uuid
                }
            });
        },
        transformVariationName: function(decodedVariationCode) {
            let variationCode = "";
            if (decodedVariationCode.length >= 1) {
                for (const code of decodedVariationCode) {
                    variationCode += code.value + " - ";
                }
                return variationCode.substring(0, variationCode.length - 3);
            } else {
                return "N/A";
            }
        }
    },
    computed: {
        ...mapState("estoreLocations", [
            "loading",
            "errors",
            "modal",
            "branchInfo",
            "productInventoryListByBranch",
            "param",
            "editingFromLocationsPage"
        ])
    },
    watch: {
        param: function(param) {
            this.$store.dispatch(
                "estoreLocations/getListProductInventoryByBranch",
                param
            );
        }
    }
};
</script>
